export const GCP_INTEGRATION = {
  TITLE: 'Connect your GCP projects',
  ERRORS: {
    SAVE_ERROR: 'Error finishing the integration, please try again or contact support',
    UPLOAD_KEY_ERROR: 'Error uploading the key, please try again or contact support',
  },
  SUCCESS: {
    INTEGRATION_COMPLETED: 'Integration completed successfully',
  },
  STEP1: {
    HELPER_TAG: 'Choose if you want to integrate one or multiple projects',
    SINGLE_PROJECT: {
      TITLE: 'Single GCP project',
      DESCRIPTION: 'If you manage everything from a single GCP project.',
    },
    MULTI_PROJECT: {
      TITLE: 'Multiple GCP projects',
      DESCRIPTION: 'For multi-project setups or organizations',
    },
  },
  STEP2_SINGLE: {
    HELPER_TAG: 'Provide your GCP project metadata to start the process.',
    PROJECT_ID_LABEL: 'GCP project ID',
    PROJECT_ID_HELPER: 'Unique project identifier',
    PROJECT_ID_ERROR: 'Please enter your project ID',
    PROJECT_NAME_LABEL: 'Project display name',
    PROJECT_NAME_HELPER: 'Used inside Qalea',
    PROJECT_NAME_ERROR: 'Please enter a project display name',
  },
  STEP2_MULTI: {
    HELPER_TAG: 'Describe the GCP projects you want to manage.',
    HOME_PROJECT_ID_LABEL: 'Home project ID',
    HOME_PROJECT_NAME_LABEL: 'Home project name',
    PROJECT_ID_LABEL: 'Project ID',
    PROJECT_NAME_LABEL: 'Project name',
    ADD_PROJECT: 'Add another project',
    AT_LEAST_ONE_PROJECT_ERROR: 'Please enter at least one project with ID and name',
  },
  STEP3_SINGLE: {
    HELPER_TAG: 'Enable the required APIs in your GCP project manually or by running a command.',
    ENABLE_MANUALLY_TITLE: 'Enable APIs manually',
    ENABLE_MANUALLY_DESCRIPTION: 'Manually open each API in console and enable them.',
    OPEN_IN_CONSOLE: 'Open in Console',
    OR_DIVIDER: 'or',
    RUN_COMMAND: 'Run the following command',
    PREREQS_DESCRIPTION: 'Run this command to enable the necessary APIs for Qalea integration.',
    API_CHECKLIST: {
      CLOUD_RESOURCE_MANAGER: 'Cloud Resource Manager API',
      SERVICE_USAGE: 'Service Usage API',
      COMPUTE_ENGINE: 'Compute Engine API',
    },
  },
  STEP3_MULTI: {
    HELPER_TAG: 'Enable the required APIs in all your GCP projects.',
    ENABLE_MANUALLY_TITLE: 'Enable APIs manually for each project',
    HOME_BADGE: 'Home',
    OR_DIVIDER: 'or',
    RUN_COMMAND: 'Run the following command',
    PREREQS_DESCRIPTION: 'Run this command to enable the necessary APIs across all projects.',
    API_CHECKLIST: {
      CLOUD_RESOURCE_MANAGER: 'Cloud Resource Manager API',
      SERVICE_USAGE: 'Service Usage API',
      COMPUTE_ENGINE: 'Compute Engine API',
    },
  },
  STEP4_SINGLE: {
    HELPER_TAG: 'Create a Service Account and grant it the necessary permissions.',
    CLI_TAB: 'CLI',
    TERRAFORM_TAB: 'Terraform',
    CLI_TITLE: 'Create Service Account via gcloud CLI',
    TERRAFORM_TITLE: 'Create Service Account via Terraform',
  },
  STEP4_MULTI: {
    HELPER_TAG: 'Create a Service Account in your home project and grant it access to all projects.',
    CLI_TAB: 'CLI',
    TERRAFORM_TAB: 'Terraform',
    CLI_TITLE: 'Create Service Account via gcloud CLI',
    TERRAFORM_TITLE: 'Create Service Account via Terraform',
  },
  STEP5: {
    HELPER_TAG: 'Upload or paste the JSON key file generated in the previous step.',
    UPLOAD_TITLE: 'Upload JSON key file',
    UPLOAD_BUTTON: 'Select file',
    PASTE_LABEL: 'Paste JSON key file content',
    UPLOAD_ERROR: 'Please upload or paste a valid JSON key',
    OR_DIVIDER: 'or',
  },
  FOOTER: {
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    BACK: 'Back',
    UPLOAD: 'Upload key',
  },
  STEP_PROGRESS_SINGLE: ['Project Type', 'Project Details', 'Enable APIs', 'Service Account', 'Upload Key'],
  STEP_PROGRESS_MULTI: ['Project Type', 'Project Details', 'Enable APIs', 'Service Account', 'Upload Key'],
}
